export default "__VITE_ASSET__BxlvuWrh__"